module.exports = __webpack_public_path__ + "img/times-background-red.f2ded7e0.svg";